var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticClass:"largeBtn",attrs:{"type":"primary"},on:{"click":_vm.backMeth}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }